import React from 'react';
import { Reveal } from './Reveal';
import { TiltCard } from './TiltCard';
import { MagneticButton } from './MagneticButton';
import { useContent } from '../content/ContentProvider';
import type { Project } from '../content/types';
import '../styles/glass.css';

const ProjectCard: React.FC<{ p: Project }> = ({ p }) => {
  const { portfolio } = useContent();
  const { blockLabels } = portfolio;

  if (p.cta) {
    return (
      <div className={`pc-slot ${p.span}`}>
        <TiltCard>
          <Reveal className="project-card glass-strong">
            <div className="pc-top">
              <span className="pc-tag">{p.tag}</span>
              <span className="pc-num">{p.n}</span>
            </div>
            <h3>{p.title}</h3>
            <p className="small">{portfolio.ctaBody}</p>
            <div style={{ marginTop: 'auto' }}>
              <MagneticButton as="a" className="btn-glass primary" href="#contact">
                {portfolio.ctaButton}
              </MagneticButton>
            </div>
          </Reveal>
        </TiltCard>
      </div>
    );
  }

  return (
    <div className={`pc-slot ${p.span}`}>
      <TiltCard>
        <Reveal className={`project-card glass-soft ${p.featured ? 'featured' : ''}`.trim()}>
          <div className="pc-top">
            <span className="pc-tag">{p.tag}</span>
            <span className="pc-num">{p.n}</span>
          </div>
          <h3>{p.title}</h3>
          <div className="pc-blocks">
            <div className="pc-block">
              <div className="pc-block-head">{blockLabels.asked}</div>
              <ul>{p.asked?.map((s) => <li key={s}>{s}</li>)}</ul>
            </div>
            <div className="pc-block">
              <div className="pc-block-head">{blockLabels.built}</div>
              <ul>{p.built?.map((s) => <li key={s}>{s}</li>)}</ul>
            </div>
            <div className="pc-block changed">
              <div className="pc-block-head">{blockLabels.changed}</div>
              <ul>{p.changed?.map((s) => <li key={s}>{s}</li>)}</ul>
            </div>
          </div>
          <div className="pc-client">{p.client}</div>
        </Reveal>
      </TiltCard>
    </div>
  );
};

export const Portfolio: React.FC = () => {
  const { portfolio } = useContent();

  return (
    <section id="portfolio">
      <Reveal className="projects-banner glass">
        <div>
          <div className="eyebrow" style={{ marginBottom: 16 }}>
            {portfolio.eyebrow}
          </div>
          <h2 className="display-h2" dangerouslySetInnerHTML={{ __html: portfolio.headingHtml }} />
        </div>
        <div className="year">{portfolio.year}</div>
      </Reveal>

      <div className="projects-grid">
        {portfolio.projects.map((p) => (
          <ProjectCard key={p.n} p={p} />
        ))}
      </div>
    </section>
  );
};
